export default __webpack_public_path__ + "static/media/Forward March.74dd2d9b.png";